import React, { useCallback, useRef, useState, useMemo } from "react";
import { connect } from "react-redux";
import { LoadPanel } from "devextreme-react/load-panel";
import DropDownButton from 'devextreme-react/drop-down-button';
import { Button, Popup } from 'devextreme-react';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';
import {MESSAGES} from "../../../common/Messages";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring

} from "devextreme-react/data-grid";
import AutoGenerateCrate from "../transactions/dataentry/AutoGenerateCrate";
import AssignToCrate from "../transactions/dataentry/AssignToCrate";
import ChangeCrateDetailQuantityPopup from "./ChangeCrateDetailQuantityPopup";
import {CrateAllocationGridOptions,
    CrateDetailAllocationGridOptions,CrateAllocationLocationGridOptions} from "../../../enum/Enum";

function ShowCrateAllocationForm(props) {
    var accessToken = props.oidc.user.access_token;
    const [selectedCrate, setSelectedCrate] = useState([]);
    const [selectedCrateDetail, setSelectedCrateDetail] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const gridCratesRef = useRef(null);
    const gridCrateDetailRef = useRef(null);
    const gridLocRef = useRef(null);
    const RefereshGrid = () => {
        if (
            gridCratesRef &&
            typeof gridCratesRef.current.instance().refresh === 'function'
        ) {
            gridCratesRef.current.instance().refresh();
        }
        if (
            gridLocRef &&
            typeof gridLocRef.current.instance().refresh === 'function'
        ) {
            gridLocRef.current.instance().refresh();
            gridLocRef.current.instance().clearSelection(); 
        }
        if (
            gridCrateDetailRef &&
            typeof gridCrateDetailRef.current.instance().refresh === 'function'
        ) {
            gridCrateDetailRef.current.instance().refresh();
        }
    }
    const onLocationSelectionChanged = useCallback((e) => {
        
        const selected = e.selectedRowsData[0];
        setSelectedLocation(selected || []);
    }, []);
    const onCrateDetailSelectionChanged = useCallback((e) => {
        
        const selected = e.selectedRowsData[0];
        setSelectedCrateDetail(selected || []);
    }, []);
    const onCrateSelectionChanged = useCallback((e) => {
        
        const selected = e.selectedRowsData[0];
        setSelectedCrate(selected || []);
    }, []);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const hideLoadPanel = useCallback(() => setLoadPanelVisible(false), []);
    const [showAutoGenerateCrate, setShowAutoGenerateCrate] = useState(false);
    const [showAssignToCrate, setShowAssignToCrate] = useState(false);
    const [showChangeCrateDetailQuantityPopup, setShowChangeCrateDetailQuantityPopup] = useState(false);
    const position = { of: '#accordion-containe2' };
    const crateOptoins = { width: 230 };
    var crateDetailOptiontems = [
        { id: CrateDetailAllocationGridOptions.RemoveCrateId, name: CrateDetailAllocationGridOptions.RemoveCrateDescription },
        { id: CrateDetailAllocationGridOptions.ChangeCrateId, name: CrateDetailAllocationGridOptions.ChangeCrateDescription },
    ];
    var crateOptiontems = [
        { id: CrateAllocationGridOptions.GenerateCrateId, name: CrateAllocationGridOptions.GenerateCrateDescription },
    ];
    var locationOptiontems = [
        { id: CrateAllocationLocationGridOptions.AssignToCrateId, name: CrateAllocationLocationGridOptions.CrateDescription },
    ];
    const crateLoadUrl = "im/Crate/GetCratesByHeader";
    const crateUpdatedUrl = "im/Crate/UpdateCrate";
    const crateDetailLoadUrl = "im/Crate/GetCrateDetails";
    const locationLoadUrl = "im/Crate/GetItemTransactionLocation";
    const carateDetailDataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${crateDetailLoadUrl}`,
        loadParams: {
            headerId: selectedCrate?.rowid,
            // sort: JSON.stringify([{ selector: "keysequence", desc: false }])
        },
        // insertUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.InsertSubLotDetailsUrl}`,
        //updateUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.UpdateSubLotDetailsUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: selectedCrate?.rowid,
            };
        },


    }), [selectedCrate]);

    const locationDataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${locationLoadUrl}`,
        loadParams: {
            headerId: props.headerId,
            // sort: JSON.stringify([{ selector: "keysequence", desc: false }])
        },
        // insertUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.InsertSubLotDetailsUrl}`,
        //updateUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.UpdateSubLotDetailsUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.headerId,
            };
        },


    }), [props.headerId]);
    const crateDataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${crateLoadUrl}`,
        loadParams: {
            headerId: props.headerId,
            // sort: JSON.stringify([{ selector: "keysequence", desc: false }])
        },
        // insertUrl: `${window._env_.REACT_APP_APIS}/${data.TransactionSubLot.InsertSubLotDetailsUrl}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${crateUpdatedUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.headerId,
            };
        },


    }), [props.headerId]);
    const onCrateItemClick = (e) => {
        let value = e.itemData?.id;
        if (value == CrateAllocationGridOptions.GenerateCrateId) {
            setShowAutoGenerateCrate(true);
        } else if (value == CrateAllocationLocationGridOptions.AssignToCrateId) {
            setShowAssignToCrate(true);
        }else if (value == CrateDetailAllocationGridOptions.ChangeCrateId) {
            setShowChangeCrateDetailQuantityPopup(true);
        }else if (value == CrateDetailAllocationGridOptions.RemoveCrateId) {
            RemoveCrateDetailQuantity();
        }
    };
    const RemoveCrateDetailQuantity = async () => {
        
        try {
            setLoadPanelVisible(true);
            const formData = new FormData();
            formData.append("RowId", selectedCrateDetail?.rowid); 
            const response = await axios.put(
                `${window._env_.REACT_APP_APIS}/im/CrateDetail/Delete`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${props.oidc.user.access_token}`,
                    },
                }
            );
    
            if (response.data === true) {
                alert(MESSAGES.QUANTITY_REMOVED_SUCCESS, MESSAGES.INFORMATION);
            } else {
                alert(MESSAGES.QUANTITY_REMOVED_ERROR, MESSAGES.ERROR);
            }
    
            RefereshGrid();
    
        } catch (error) {
            console.error("Error:", error);
            alert(MESSAGES.QUANTITY_REMOVED_ERROR, MESSAGES.ERROR);
        } finally {
            setLoadPanelVisible(false);
        }
    };

    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();  
            if(selection.length == 0) {  
                e.component.selectRowsByIndexes([0]);  
            }
        }  
    };
    const onContentReadyCrateDetail = (e) => {
        
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();  
            if(selection.length == 0) {  
                e.component.selectRowsByIndexes([0]);  
            }
        }  
    };
    return (
        <div className="FormMt" style={{ height: "96%", display: "flex", flexDirection: "column", gap: "10px" }}>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />

            {/* Grid 1 */}
            <div style={{ flex: 1, overflow: "hidden" }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    id="gridCrates"
                    dataSource={crateDataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    ref={gridCratesRef}
                    height="100%"
                    onSelectionChanged={onCrateSelectionChanged}
                    onContentReady={onContentReady}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <StateStoring
                        enabled={true}
                        type="custom"
                    />
                    <Scrolling mode="standard" />
                    <Selection mode="single" />
                    <Export enabled={true} allowExportSelectedData={true} />
                    <Editing
                        mode="cell"
                        refreshMode="repaint"
                        allowUpdating={true}
                        newRowPosition="last"
                    />
                    <Column dataField="cratenumber" caption="Crate Number" />
                    <Column dataField="owner" caption="Owner" allowEditing={false} />
                    <Column dataField="warehouseName" caption="Warehouse" allowEditing={false} />
                    <Column dataField="location" caption="Location" allowEditing={false} />
                    <Column dataField="receiveddate" dataType="date" format="MM/dd/yyyy" caption='Received Date' />
                    <Column dataField="description" caption="Description" />
                    <Column dataField="dimensions" caption="Dimensions" visible={false} />
                    <Column dataField="height" caption="Height" visible={false} />
                    <Column dataField="width" caption="Width" visible={false} />
                    <Column dataField="depth" caption="Depth" visible={false} />
                    <Column dataField="grossweightquantity" caption="Gross Weight Quantity" visible={false} />
                    <Column dataField="netweightquantity" caption="Net Weight Quantity" visible={false} />
                    <Column dataField="comment" caption="Comment" visible={false} />
                    <Column dataField="voyagenumber" caption="Voyage Number" visible={false} />
                    <Column dataField="relationship" caption="Relationship" visible={false} />
                    <Column dataField="userdefinedcode1" caption="User Defined Code 1" visible={false} />
                    <Column dataField="userdefinedcode2" caption="User Defined Code 2" visible={false} />
                    <Column dataField="userdefinedcode3" caption="User Defined Code 3" visible={false} />
                    <Column dataField="userdefinedcode4" caption="User Defined Code 4" visible={false} />
                    <Column dataField="userdefinedcode5" caption="User Defined Code 5" visible={false} />
                    <Column dataField="userdefineddate1" caption="User Defined Date 1" visible={false} />
                    <Column dataField="userdefineddate2" caption="User Defined Date 2" visible={false} />
                    <Column dataField="userdefineddate3" caption="User Defined Date 3" visible={false} />
                    <Column dataField="userdefineddate4" caption="User Defined Date 4" visible={false} />
                    <Column dataField="userdefineddate5" caption="User Defined Date 5" visible={false} />
                    <Column dataField="userdefinedreference1" caption="User Defined Reference 1" visible={false} />
                    <Column dataField="userdefinedreference2" caption="User Defined Reference 2" visible={false} />
                    <Column dataField="userdefinedreference3" caption="User Defined Reference 3" visible={false} />
                    <Column dataField="userdefinedreference4" caption="User Defined Reference 4" visible={false} />
                    <Column dataField="userdefinedreference5" caption="User Defined Reference 5" visible={false} />
                    <Column dataField="userdefinedquantity1" caption="User Defined Quantity 1" visible={false} />
                    <Column dataField="userdefinedquantity2" caption="User Defined Quantity 2" visible={false} />
                    <Column dataField="userdefinedquantity3" caption="User Defined Quantity 3" visible={false} />
                    <Column dataField="userdefinedquantity4" caption="User Defined Quantity 4" visible={false} />
                    <Column dataField="userdefinedquantity5" caption="User Defined Quantity 5" visible={false} />
                    <Column dataField="userdefinedcomment" caption="User Defined Comment" visible={false} />
                    <Column dataField="tareweightquantity" caption="Tare Weight Quantity" visible={false} />
                    <Column dataField="cube" caption="Cube" visible={false} />
                    <Column dataField="ssccnumber" caption="SSCC Number" visible={false} />


                    <Toolbar>
                        <Item location="before">
                            <div style={{ fontWeight: "bold", fontSize: "16px" }}>Crates</div>
                        </Item>
                        <Item location="after">
                            <DropDownButton
                                text="Option"
                                icon="preferences"
                                dropDownOptions={crateOptoins}
                                items={crateOptiontems}
                                onItemClick={onCrateItemClick}
                                displayExpr="name"
                                keyExpr="id"
                            />
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
            </div>

            {/* Grid 2 */}
            <div style={{ flex: 1, overflow: "hidden" }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={carateDetailDataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    height="100%"
                    ref={gridCrateDetailRef}
                    onSelectionChanged={onCrateDetailSelectionChanged}
                    onContentReady={onContentReadyCrateDetail}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <StateStoring
                        enabled={true}
                        type="custom"
                    />
                    <Scrolling mode="standard" />
                    <Selection mode="single" />
                    <Export enabled={true} allowExportSelectedData={true} />
                    <Editing
                        mode="cell"
                        refreshMode="repaint"
                    />
                    <Column dataField="itemCode" caption="Item" />
                    <Column dataField="lotCode" caption="Lot" />
                    <Column dataField="subLotCode" caption="SubLot" />
                    <Column dataField="quantity" caption="Quantity Actual" format="fixedPoint" />
                    <Column dataField="crate" caption="Crate" />
                    <Column dataField="customer" caption="Customer" visible={false} />
                    <Column dataField="quantityOrdered" caption="Quantity Ordered" visible={false} />
                    <Column dataField="reference" caption="Reference" visible={false} />
                    <Column dataField="referenceDateTime" caption="Reference Date Time" visible={false} />
                    <Column dataField="worker" caption="Worker" visible={false} />

                    <Toolbar>
                        <Item location="before">
                            <div style={{ fontWeight: "bold", fontSize: "16px" }}>Crate Details</div>
                        </Item>
                        <Item location="after">
                            <DropDownButton
                                text="Option"
                                icon="preferences"
                                dropDownOptions={crateOptoins}
                                items={crateDetailOptiontems}
                                onItemClick={onCrateItemClick}
                                displayExpr="name"
                                keyExpr="id"
                                disabled={selectedCrateDetail.length === 0}
                            />
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
            </div>

            {/* Grid 3 */}
            <div style={{ flex: 1, overflow: "hidden" }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={locationDataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    height="100%"
                    onSelectionChanged={onLocationSelectionChanged}
                    ref={gridLocRef}
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <StateStoring
                        enabled={true}
                        type="custom"
                    />
                    <Scrolling mode="standard" />
                    <Selection mode="single" />
                    <Export enabled={true} allowExportSelectedData={true} />
                    <Editing
                        mode="cell"
                        refreshMode="repaint"
                    />
                    <Column dataField="itemCode" caption="Item" />
                    <Column dataField="lotCode" caption="Lot" />
                    <Column dataField="subLotCode" caption="SubLot" />
                    <Column dataField="wareHouse" caption="Warehouse" />
                    <Column dataField="locationCode" caption="Location" />
                    <Column dataField="quantity" caption="Quantity" format="fixedPoint" />
                    <Column dataField="remaningQuantity" caption="Remaning Quantity" format="fixedPoint" />

                    <Toolbar>
                        <Item location="before">
                            <div style={{ fontWeight: "bold", fontSize: "16px" }}>Transaction Item Locations</div>
                        </Item>
                        <Item location="after">
                            <DropDownButton
                                text="Option"
                                icon="preferences"
                                dropDownOptions={crateOptoins}
                                items={locationOptiontems}
                                onItemClick={onCrateItemClick}
                                displayExpr="name"
                                keyExpr="id"
                                disabled={
                                    selectedCrate.length === 0 || 
                                    selectedLocation.length === 0 ||
                                    (selectedLocation?.quantity == null || selectedLocation?.quantity == undefined || selectedLocation?.quantity == 0)
                                  }
                            />
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
            </div>
            {showAutoGenerateCrate && (
                <Popup
                    visible={showAutoGenerateCrate}
                    onHiding={() => setShowAutoGenerateCrate(false)}
                    width="20vw"
                    height="15vw"
                    title="Quantity"
                    showCloseButton={true}
                >
                    <div style={{ height: "96%", overflow: "hidden" }}>
                        <AutoGenerateCrate RefereshGrid={RefereshGrid} onClosePopup={() => setShowAutoGenerateCrate(false)} />
                    </div>
                </Popup>
            )}
            {showAssignToCrate && (
                <Popup
                    visible={showAssignToCrate}
                    onHiding={() => setShowAssignToCrate(false)}
                    width="20vw"
                    height="35vh"
                    title="Enter Crate Quantity"
                    showCloseButton={true}
                >
                    <div style={{ height: "96%", overflow: "hidden" }}>
                        <AssignToCrate headerId={props.headerId} selectedCrate={selectedCrate} selectedLocation={selectedLocation} RefereshGrid={RefereshGrid} onClosePopup={() => setShowAssignToCrate(false)} />
                    </div>
                </Popup>
            )}
             {showChangeCrateDetailQuantityPopup && (
                <Popup
                    visible={showChangeCrateDetailQuantityPopup}
                    onHiding={() => setShowChangeCrateDetailQuantityPopup(false)}
                    width="20vw"
                    height="35vh"
                    title="Change Crate Detail Quantity"
                    showCloseButton={true}
                >
                    <div style={{ height: "96%", overflow: "hidden" }}>
                        <ChangeCrateDetailQuantityPopup selectedCrateDetail={selectedCrateDetail}   RefereshGrid={RefereshGrid} onClosePopup={() => setShowChangeCrateDetailQuantityPopup(false)} />
                    </div>
                </Popup>
            )}
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(ShowCrateAllocationForm);
